module.exports = __webpack_public_path__ + "img/cmi_logo_black.acae4814.png";